import { Status, Protocol } from '../library/constants'
import { logger } from '../functions/logger/logger'

export class WS {
  reconnectTimeout = 0
  pingInterval = 0
  msgBuffer = ''
  
  count = 0
  gameObject = null
  websocket = null
  interfaceReq = [
    { name: 'WS_URL', type: 'string', fatal: true },
    { name: 'doMessage', type: 'function', fatal: true },
    { name: 'setStatus', type: 'function', fatal: true }
  ]

  Init(_game) {
    this.gameObject = _game

    if (this.gameObject === null) {
      throw new Error('Game Object is null')
    }

    this.interfaceReq.forEach((item) => {
      if (typeof this.gameObject[item.name] !== item.type) {
        if (item.fatal) {
          throw new Error('Game.' + item.name + ' is not defined')
        } else {
          logger.log(
            'Game.' +
              item.name +
              ' is not defined, you will not receive this event'
          )
        }
      }
    })

    return this
  }

  Start() {
    logger.log('%cStart websocket to ' + this.gameObject.WS_URL, 'color:brown')
    try {
      var _this = this
      this.websocket = new WebSocket(this.gameObject.WS_URL)

      this.websocket.onerror = function (evt) {
        _this.onerror(evt)
      }
      this.websocket.onopen = function (evt) {
        _this.onopen(evt)
      }
      this.websocket.onmessage = function (evt) {
        _this.onmessage(evt)
      }
      this.websocket.onclose = function (evt) {
        _this.onerror(evt)
      }
    } catch (err) {
      // console.log(err);
    }
    return this
  }

  sendMessage(msg) {
    if (msg !== Protocol.PING) {
        this.count = 0
      // TODO es wava loggershi
      const styles = [
        'background: linear-gradient(#D33106, #571402)',
        'border: 1px solid #3E0E02',
        'color: white',
        'display: block',
        'text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3)',
        'box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset, 0 5px 3px -5px rgba(0, 0, 0, 0.5), 0 -13px 5px -10px rgba(255, 255, 255, 0.4) inset',
        'line-height: 30px',
        'text-align: center',
        'font-weight: bold'
      ].join(';')

      const splitted = msg.split(',')
      logger.log(
        `%c⬆️ ${Object.keys(Protocol).find(
          (key) => Protocol[key] === splitted[0]
        )} ⬆️  ${splitted}`,
        styles
      )
    }

    if (this.websocket.readyState === WebSocket.OPEN) {
      this.websocket.send(msg + Protocol.END_MESSAGE)
    }
    // else {
    //   clearTimeout(this.reconnectTimeout);
    //   clearInterval(this.pingInterval);
    //   var self = this;
    //   this.reconnectTimeout = setTimeout(function() {
    //     self.reconnect();
    //   }, 3000);
    // }
  }

  pingIntervalFunc(self) {
    self.count++
    if(self.count === 60) {
      self.Disconnect()
    }
    self.sendMessage(Protocol.PING)
  }

  // reconnect() {
  //   clearInterval(this.pingInterval);
  //   this.websocket.onerror = null;
  //   this.websocket.onopen = null;
  //   this.websocket.onmessage = null;
  //   this.websocket.onclose = null;
  //   this.Start();
  // }

  onerror(evt) {
    this.gameObject.setStatus(Status.DISCONNECTED)

    // console.log("onerror ", evt);
    clearTimeout(this.reconnectTimeout)
    clearInterval(this.pingInterval)
    // var self = this;
    // this.reconnectTimeout = setTimeout(function() {
    //   self.reconnect();
    // }, 3000);
  }

  Disconnect() {
    clearInterval(this.pingInterval)
    clearTimeout(this.reconnectTimeout)
    this.gameObject.setStatus(Status.DISCONNECTED)

    this.websocket.onerror = null
    this.websocket.onopen = null
    this.websocket.onmessage = null
    this.websocket.onclose = null
    this.msgBuffer = ''
    this.websocket.close()
  }

  onopen(evt) {
    // console.log("%conopen ", "color :brown");
    this.gameObject.setStatus(Status.CONNECTED)
    this.pingInterval = setInterval(
      this.pingIntervalFunc.bind(null, this),
      5000
    )
  }

  onmessage(evt) {
    var msg = evt.data
    this.msgBuffer += msg

    if (this.msgBuffer.indexOf(Protocol.END_MESSAGE) !== -1) {
      var splited = this.msgBuffer.split(Protocol.END_MESSAGE)

      splited.forEach((item) => {
        if (item.length > 0) this.gameObject.doMessage(item)
      })

      this.msgBuffer = splited[splited.length - 1]
    }
  }
}

// export default WS;
